import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { jsx } from '../../jsx';
import PolarX from './polar/polar-x';
import PolarY from './polar/polar-y';
import Top from './rect/top';
import Bottom from './rect/bottom';
import Right from './rect/right';
import Left from './rect/left';

function isPolar(props) {
  return props.coord.isPolar;
}

export default (function (props) {
  // 极坐标
  if (isPolar(props)) {
    var dimType = props.dimType;

    if (dimType === 'x') {
      return jsx(PolarX, _objectSpread({}, props));
    }

    return jsx(PolarY, _objectSpread({}, props));
  }

  var position = props.position; // 直角坐标

  if (position === 'right') {
    return jsx(Right, _objectSpread({}, props));
  }

  if (position === 'left') {
    return jsx(Left, _objectSpread({}, props));
  }

  if (position === 'top') {
    return jsx(Top, _objectSpread({}, props));
  }

  return jsx(Bottom, _objectSpread({}, props));
});